module.exports = __webpack_public_path__ + "static/0-collecting-b456d210a05fcb49ff5cfcae50e86156.svg";